import { render } from "./HeroAuthTravelDashboard.vue?vue&type=template&id=079a3612&scoped=true"
import script from "./HeroAuthTravelDashboard.vue?vue&type=script&lang=js"
export * from "./HeroAuthTravelDashboard.vue?vue&type=script&lang=js"

import "./HeroAuthTravelDashboard.vue?vue&type=style&index=0&id=079a3612&scoped=true&lang=css"

import exportComponent from "/Users/alvinvergara/Developer/Lead Dev - Projects/DAP/iwc_dap/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-079a3612"]])

export default __exports__